import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { API_URL } from '../../const/api'
import { selectCurrency, selectId, selectLogged, selectToken, setNewToken } from '../../features/user/userSlice'
import { getEstadoBono, toLocale } from '../../utils/tools'
import Modal from '../modals/ModalBoth'
import { BonosContainer, ButtonClose, Container, ModalTitle, Table } from './BonosElements'
import CloseIcon from '@mui/icons-material/Close';
import BonoModal from './BonoModal'
import { useTranslation } from 'react-i18next'
import { selectUserBonos, setShowUserBonos } from '../../features/modals/modalsSlice'
import Loader from '../common/Loader';
const BonosModal = () => {
  const [t] = useTranslation('global');
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);
  const open = useSelector(selectUserBonos);
  const isLoged = useSelector(selectLogged);

  const dispatch = useDispatch();
  const [bonos, setBonos] = useState([]);
  const [selectedBono, setSelectedBono] = useState(null);
  const [openBonoModal, setOpenBonoModal] = useState(false);
  const [hayBonos, setHayBonos] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => dispatch(setShowUserBonos(false));

  const showBono = async (bono) => {
    const res = await axios.post(API_URL+'detallesBono', {id_uo, token, moneda, id: bono.id});
    dispatch(setNewToken(res.data.token));
    if(res.data.status===1) {
      if(res.data.response.estado) {
        if(res.data.response.estado==='0') {
          //console.log("no hay detalles del bono");
        } else {
          setSelectedBono({...res.data.response, id: bono.id});
          setOpenBonoModal(true);
        }
      }
    }
  }

  useEffect(()=>{
    const loadData = async () => {
      setLoading(true);
      const res = await axios.post(API_URL+'loadBonos', {id_uo, token});
      dispatch(setNewToken(res.data.token));
      if(res.data.status===1) {
        if(Array.isArray(res.data.response)) {
          setBonos(res.data.response);
          setHayBonos(true);
        } else {
          setHayBonos(false);
          setMensaje(res.data.response);
        }
        setLoading(false);
      }
    }
    if(isLoged) {
      loadData();
    }
  },[])

  return (
    isLoged &&
    <Modal open={open} handleClose={handleClose} maxWidth='sm' fullWidth={false} children={
      <Container>
        <ModalTitle>
          <h2>{t('bonos.title')}</h2>
          <ButtonClose onClick={handleClose}>
            <CloseIcon/>
          </ButtonClose>
        </ModalTitle>
        <BonosContainer>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <th>{t('bonos.bono')}</th>
                <th>{t('bonos.value')}</th>
                <th>ROLLOVER</th>
                <th>{t('bonos.vence')}</th>
                <th>{t('bonos.status')}</th>
              </tr>
            </thead>
            <tbody>
              {(hayBonos && bonos.length>0) && bonos.map(item => (
                <tr className='row' onClick={()=>showBono(item)} key={item.nombre+item.id}>
                <td>{item.id}</td>
                <td>
                  {item.nombre}
                </td>
                <td>{toLocale(Math.floor((Math.floor((item.valor_rollover / item.rollover)*(item.valor_bono / 100)))*100)/100)}</td>
                <td>
                  X {item.rollover}
                </td>
                <td>{item.fecha_vence}</td>
                <td className={getEstadoBono(item.estado).clase}><span>{t(`bonos.${getEstadoBono(item.estado).title}`)}</span></td>
              </tr>
              ))}
            </tbody>
          </Table>
          {loading && <Loader />}
          {!hayBonos && <div className='no_bono'>{mensaje}</div>}
        </BonosContainer>
        {selectedBono && <BonoModal bono={selectedBono} open={openBonoModal} setOpen={setOpenBonoModal} setBono={setSelectedBono} />}
      </Container>
    } />
  )
}

export default BonosModal